<template>
  <section>
    <div class="w-8/12 sm:w-4/5 form-font">
      <div></div>
      <p class="text-red-500" v-if="errorMessage.length != 0">{{ displayErrorMessage }}</p>
      <p class="text-red-500">{{ successMessage }}</p>
      <div class="contact-us-form">
        <form class="contact-form" @submit.prevent="submit">
          <div>
            <input
              type="text"
              name="your-name"
              id="your-name"
              placeholder="YOUR NAME"
              class="border-b-2 focus:outline-none bg-black w-full my-12 text-white"
              v-model="yourname"
            />
          </div>
          <div>
            <input
              type="email"
              name="your-email"
              id="your-email"
              placeholder="EMAIL"
              class="border-b-2 focus:outline-none bg-black w-full my-12 text-white"
              v-model="youremail"
            />
          </div>
          <div>
            <input
              type="textarea"
              name="your-message"
              id="your-message"
              placeholder="LEAVE US MESSAGE"
              class="border-b-2 focus:outline-none bg-black w-full my-12 text-white"
              v-model="yourmessage"
            />
          </div>
          <div>
            <input
              class="w-60 h-16 my-12 bg-black text-white border-2 border-white cursor-pointer"
              type="submit"
              value="SEND"
              @click="onSubmit"
            />
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      yourname: "",
      youremail: "",
      yourmessage: "",
      errorMessage: [],
      successMessage: ""
    };
  },
  methods: {
    onSubmit() {
      console.log("trigger form submit");
      this.errorMessage = [];
      this.validateForm();
      //send the form out
      if (this.errorMessage.length != 0) {
        return;
      }
      let formData = new FormData();
      formData.append("yourname", this.yourname);
      formData.append("youremail", this.youremail);
      formData.append("yourmessage", this.yourmessage);
      axios
        .post("/wp-json/contact-form-7/v1/contact-forms/19/feedback", formData)
        .then(res => {
          // Perform success action
          console.log(res);
          this.successMessage = "Email Successfully Sent";
        })
        .catch(error => {
          // handle error

          console.log(error);
          this.errorMessage.push("Error sending Message");
        })
        .finally(() => {
          // perform action always
          return;
        });
    },
    validateForm() {
      if (
        this.yourname == "" ||
        this.youremail == "" ||
        this.yourmessage == ""
      ) {
        this.errorMessage.push("Please Fill in the required field");
      }
    }
  },
  computed: {
    displayErrorMessage() {
      return this.errorMessage[0];
    }
  }
};
</script>

<style scoped>
.form-font {
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  text-transform: uppercase;
}
</style>